import React, { useEffect, useState } from 'react';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import serviceImage1 from '../../assets/images/services-img1.jpg'
import serviceImage2 from '../../assets/images/services-img2.jpg'
import bannerRates from '../../assets/images/banner-rates.png'
import watchImage from '../../assets/images/watch.png'
import dogShape1 from '../../assets/images/dog-shape1.png'
import dogShape2 from '../../assets/images/dog-shape2.png'
import dogShape3 from '../../assets/images/dog-shape3.png'
import dogShape4 from '../../assets/images/dog-shape4.png'

import houseShape1 from '../../assets/images/house-shape1.png'
import houseShape2 from '../../assets/images/house-shape2.png'
import houseShape3 from '../../assets/images/house-shape3.png'
import houseShape4 from '../../assets/images/house-shape4.png'

const Rates = (props: any) => {
    return (
        <div>
            <section className="contactme-banner">
                <div className="container">
                </div>
            </section>
            <section className="service-rate-wrap">
                <div className="container">
                    <div className="row justify-content-center">
                    <h2 className="text-center m-5">
      Please <a href="mailto:lexi@lexination.com" className="text-blue-600 underline">email</a> me for pricing details.
    </h2>

                    </div>
                </div>
            </section>
        </div>
    );

}

export default Rates;

